import { useState } from 'react';
import { Input, Checkbox, Button } from 'antd';
import { SearchOutlined, StopOutlined } from '@ant-design/icons';
import '../groupSelect/styles.scss';

export interface CustomOption {
  id:    string;
  label: string;
}

interface Props {
  open:      boolean;
  onClose:   () => void;
  onSelect?: (ids: string[]) => void;
  selected?: string[];
  options?:  CustomOption[];
}

const NONE_ID = '__none__';

const CustomFieldSelect = ({ open, onClose, onSelect, selected = [], options = [] }: Props) => {
  const [search, setSearch] = useState('');
  const [picked, setPicked] = useState<string[]>(selected);

  const filtered = options.filter(o => o.label.toLowerCase().includes(search.toLowerCase()));
  const showNone = 'no value set'.includes(search.toLowerCase()) || !search.trim();

  const toggle = (id: string) =>
    setPicked(prev => (prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]));

  const handleDone = () => {
    onSelect?.(picked);
    onClose();
  };

  if (!open) return null;

  return (
    <div className="group-select">
      <div className="gs-search">
        <Input
          placeholder="Search"
          prefix={<SearchOutlined style={{ color: '#999' }} />}
          value={search}
          onChange={e => setSearch(e.target.value)}
        />
      </div>

      <div className="gs-list">
        {showNone && (
          <div className="gs-item" onClick={() => toggle(NONE_ID)}>
            <span className="gs-none-icon"><StopOutlined /></span>
            <span className="gs-label">No value set</span>
            <Checkbox
              checked={picked.includes(NONE_ID)}
              onClick={e => e.stopPropagation()}
              onChange={() => toggle(NONE_ID)}
            />
          </div>
        )}

        {filtered.map(o => (
          <div key={o.id} className="gs-item" onClick={() => toggle(o.id)}>
            <span className="gs-label">{o.label}</span>
            <Checkbox
              checked={picked.includes(o.id)}
              onClick={e => e.stopPropagation()}
              onChange={() => toggle(o.id)}
            />
          </div>
        ))}

        {!showNone && filtered.length === 0 && <div className="gs-empty">No values found</div>}
      </div>

      <div className="gs-done">
        <Button type="primary" block size="large" onClick={handleDone}>
          ✓ DONE
        </Button>
      </div>
    </div>
  );
};

export default CustomFieldSelect;
